const reverseCloneElement = (contentToWrap, firstRefElement, lastRefElement) => {
  const cloneRecursively = (node, children) => {
    const clonedNode = node.cloneNode();
    children.forEach((child) => clonedNode.appendChild(child));

    if (node === lastRefElement) {
      return clonedNode;
    }

    return cloneRecursively(node.parentElement, [clonedNode]);
  };

  let children = [contentToWrap];

  if (typeof contentToWrap === 'string') {
    // Create a wrapper element to transform text to HTML
    const wrapper = document.createElement('div');
    wrapper.innerHTML = contentToWrap;

    // Collect all child nodes of the wrapper
    children = Array.from(wrapper.childNodes);
  }

  return cloneRecursively(firstRefElement, children);
};

export default reverseCloneElement;
